import PropTypes from 'prop-types';
import React from 'react';

import { SERVICE_REGISTRY } from '../constants';

const listFmt = new Intl.ListFormat('en', {
  style: 'long',
  type: 'disjunction',
});

function formatServiceNames(services, useSingular) {
  const property = useSingular ? 'singular' : 'plural';
  const names = services
    .map(service => SERVICE_REGISTRY[service]?.[property])
    .filter(Boolean);
  return listFmt.format(names);
}

function ServiceUnavailableAlert({
  headerLevel = 3,
  heading,
  services,
  testId,
  useSingular = false,
}) {
  if (!heading && !services?.length) return null;

  const HeadingTag = `h${headerLevel}`;

  let headingText = heading;
  if (!headingText) {
    const names = formatServiceNames(services, useSingular);
    headingText = useSingular
      ? `We can't access your ${names} right now`
      : `We can't access some of your ${names} right now`;
  }

  return (
    <va-alert
      class="vads-u-margin-top--1 vads-u-margin-bottom--3"
      data-testid={testId}
      status="warning"
    >
      <HeadingTag slot="headline">{headingText}</HeadingTag>
      <p className="vads-u-margin-top--0">
        We're sorry. There's a problem with our system. Refresh this page or try
        again later.
      </p>
      <p className="vads-u-margin-top--0 vads-u-margin-bottom--0">
        If it still doesn't work, call us at{' '}
        <va-telephone contact="8008271000" /> (
        <va-telephone contact="711" tty="true" />
        ). We're here Monday through Friday, 8:00 a.m. to 9:00 p.m. ET.
      </p>
    </va-alert>
  );
}

ServiceUnavailableAlert.propTypes = {
  headerLevel: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  heading: PropTypes.string,
  services: PropTypes.arrayOf(PropTypes.oneOf(Object.keys(SERVICE_REGISTRY))),
  testId: PropTypes.string,
  useSingular: PropTypes.bool,
};

export default ServiceUnavailableAlert;
